import { memo, ReactNode } from 'react'
import IconDots from 'assets/dots-icon.svg?react'
import cn from 'classnames'
import { getContactFullName, getContactFullPhone } from 'modules/contact/helpers'
import { TContact } from 'modules/contact/types'
import { Button } from 'shared/components'
import { ListCard, ListCardRow, ListCardTable, ListRow } from 'src/tailwind-components/extends/List'
import { PlaceholderCell } from 'src/tailwind-components/extends/PlaceholderCell'
import { Dropdown } from 'src/tailwind-components/shared/components/Dropdown'

import DropdownActions from '../../../DropdownActions/DropdownActions'

import s from '../../styles.module.less'
import cs from 'src/common.module.less'

type TProps = {
  className?: string
  deleteButton?: ReactNode | string
  isMobile?: boolean
  item?: TContact
  onClick?: () => void
  onDeleteButtonClick?: (e: React.SyntheticEvent) => void
  onUpdateButtonClick?: (e: React.SyntheticEvent) => void
  updateButton?: ReactNode | string
}

const TableColumn = memo(function TableColumn({
  className,
  isMobile,
  item,
  onClick,
  deleteButton,
  onDeleteButtonClick,
  updateButton,
  onUpdateButtonClick
}: TProps) {
  return isMobile ? (
    <ListCard
      className={cn(s.mobileName)}
      header={getContactFullName(item) || '—'}
      onClick={onClick}
      testId="contact--table--column"
    >
      <ListCardTable>
        <ListCardRow className={cn(s.mobileCardRow, cs.marginB4)}>
          <div className={s.mobileTitleRow}>Телефон</div>
          <div className={s.mobileContent}>{getContactFullPhone(item)}</div>
        </ListCardRow>
        <ListCardRow className={cn(s.mobileCardRow)}>
          {/* eslint-disable-next-line */}
          <div className={s.mobileTitleRow}></div>
          <div
            className={cn(s.mobileContent, s.mobileUpdate)}
            onClick={(e: React.SyntheticEvent) => onUpdateButtonClick && onUpdateButtonClick(e)}
          >
            <span>Редактировать</span>
          </div>
          <div
            className={cn(s.mobileContent, s.mobileDelete)}
            onClick={(e: React.SyntheticEvent) => onDeleteButtonClick && onDeleteButtonClick(e)}
          >
            <span>Удалить</span>
          </div>
        </ListCardRow>
      </ListCardTable>
    </ListCard>
  ) : (
    <ListRow className={cn(className, s.item)} onClick={onClick} testId="contact--table--column">
      <div className={cn(s.contactName, 'break-all')}>
        {item ? getContactFullName(item) : <PlaceholderCell height={20} />}
      </div>
      <div className={cn(s.phone)}>{item ? getContactFullPhone(item) : <PlaceholderCell height={20} />}</div>
      <div className="flex">
        {item ? (
          <Dropdown
            isFullscreenInMobile
            placement="bottom-end"
            // eslint-disable-next-line react/no-unstable-nested-components
            dropdownRender={({ handleClose }) => (
              <DropdownActions
                deleteButton={deleteButton}
                onClose={handleClose}
                onDeleteButtonClick={onDeleteButtonClick}
                onUpdateButtonClick={onUpdateButtonClick}
                updateButton={updateButton}
              />
            )}
          >
            {({ handleToggle, ref }) => (
              <div ref={ref}>
                <Button className={cn(s.actionsButton, 'h-[unset]')} onClick={handleToggle} size="lg" variant="text">
                  <IconDots size="sm" />
                </Button>
              </div>
            )}
          </Dropdown>
        ) : (
          <PlaceholderCell height={20} />
        )}
      </div>
    </ListRow>
  )
})

export default TableColumn
